import React from 'react';
import styled from 'styled-components';
import { SubmenuContainer } from './loadStopsInput';

const Item = styled.div`
    padding:0.5rem 0.5rem;
    .container {
        color:var(--dark-gray);
        display: block;
        position: relative;
        padding-left: 1.7rem;
        cursor: pointer;
        font-size: 1.0rem;
        font-weight: 500;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
      
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.1rem;
        width: 1.1rem;
        box-shadow: var(--button-outline);
        -moz-box-shadow: var(--button-outline);
        -webkit-box-shadow: var(--button-outline);
    }
    .container input:checked ~ .checkmark {
        background-color: var(--main-color);
    }
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    .container input:checked ~ .checkmark:after {
        display: block;
    }
    .container .checkmark:after {
        left: 0.38rem;
        top: 0.05rem;
        width: 0.29rem;
        height: 0.75rem;
        border: solid white;
        border-width: 0 0.13rem 0.13rem 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`

export const SelectionList = ({data}) => {
    const hasAccessIds = [];
    if (data.defaultValue){
        for (const comp of data.defaultValue()){
            hasAccessIds.push(parseInt(comp.id))
        }
    }
    const currentCompanyId = localStorage.getItem("currentCompanyId");
    let companies = JSON.parse(localStorage.getItem("accessibleCompanies"));
    return <SubmenuContainer>
        <div id={data.name}>
            {
                companies.map((company, index)=>{
                    return <Item key={index}>
                        <label className="container">{company.companyName}
                            <input type="checkbox" defaultChecked={parseInt(currentCompanyId) === parseInt(company.id) || hasAccessIds.includes(parseInt(company.id))} id="companySelection" data-value={JSON.stringify(company)} />
                            <span className="checkmark"></span>
                        </label>
                    </Item>
                })
            }            
        </div>  
    </SubmenuContainer>
}